import { api } from './api';

export interface PlRow {
  id: string;
  code: string | null;
  label: string;
  kind: 'section' | 'account' | 'subaccount';
  level: number;
  isSubtotal: boolean;
  sign: number;
  amountA: number;
  amountB: number | null;
  delta: number | null;
  deltaPct: number | null;
}

export interface PlResponse {
  reportingCurrency: string;
  consolidated: boolean;
  scenarioA: string;
  scenarioB: string | null;
  period: { start: string; end: string };
  rows: PlRow[];
  totals: { a: number; b: number | null };
  fx: {
    ratesUsed: { from: string; to: string; rate: number; date: string }[];
    missingRates: { from: string; to: string }[];
  };
  intercompanyExcluded: number;
}

export interface PlQuery {
  scenarioA: string;
  scenarioB?: string;
  periodStart: string;
  periodEnd: string;
  reportingCurrency: string;
  consolidated: boolean;
  rootEntityId?: string;
  view?: 'management' | 'statutory';
}

export const managementPlApi = {
  async get(wsId: string, q: PlQuery): Promise<PlResponse> {
    const r = await api.get<PlResponse>(`/api/workspaces/${wsId}/management-pl`, {
      params: {
        scenarioA: q.scenarioA,
        scenarioB: q.scenarioB || undefined,
        periodStart: q.periodStart,
        periodEnd: q.periodEnd,
        reportingCurrency: q.reportingCurrency,
        consolidated: String(q.consolidated),
        rootEntityId: q.rootEntityId || undefined,
        view: q.view || undefined,
      },
    });
    return r.data;
  },
};
